module.exports = "/_next/static/images/b2f33ffc82d9668b9f60bddcf0a73bab-roxinho-card-with-phone-md@2x.jpg";